/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Attr_Auction_DateInputs */

const cs_sreality_attr_auction_date = /** @type {(inputs: Sreality_Attr_Auction_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termín dražby`)
};

const en_sreality_attr_auction_date = /** @type {(inputs: Sreality_Attr_Auction_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auction date`)
};

/**
* | output |
* | --- |
* | "Auction date" |
*
* @param {Sreality_Attr_Auction_DateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_attr_auction_date = /** @type {((inputs?: Sreality_Attr_Auction_DateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Attr_Auction_DateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_attr_auction_date(inputs)
	return cs_sreality_attr_auction_date(inputs)
});